var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.43,
    height: 57.43,
    viewBox: "0 0 57.43 57.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8398c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#3d4b6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#2e3e69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#465f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8398c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_67",
    x: 3,
    y: 3,
    width: 51.43,
    height: 51.43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1e0060",
    floodOpacity: 0.741
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d2e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#d2ddeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#8aa2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385976"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_67-2",
    x: 0,
    y: 0,
    width: 57.43,
    height: 57.43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.537
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_ionic-ios-arrow-back",
    x: 19.742,
    y: 13.298,
    width: 15.482,
    height: 24.834,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103838",
    "data-name": "Group 103838",
    transform: "translate(-598 -269.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6483",
    "data-name": "Group 6483",
    transform: "translate(607 275.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-3",
    "data-name": "Ellipse 67",
    transform: "translate(9 6)",
    stroke: "#aacbff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.715,
    cy: 19.715,
    r: 19.715,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.715,
    cy: 19.715,
    r: 19.215,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-2",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M15.013,17.108l8.261-8.255a1.56,1.56,0,1,0-2.21-2.2L11.705,16a1.557,1.557,0,0,0-.045,2.151l9.4,9.418a1.56,1.56,0,0,0,2.21-2.2Z",
    transform: "translate(0.991 2.605)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6483-2",
    "data-name": "Group 6483",
    transform: "translate(607 275.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-2",
    "data-name": "refresh",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_67-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-4",
    "data-name": "Ellipse 67",
    transform: "translate(9 6)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.715,
    cy: 19.715,
    r: 19.715,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.715,
    cy: 19.715,
    r: 19.215,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Icon_ionic-ios-arrow-back)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-3",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M15.013,17.108l8.261-8.255a1.56,1.56,0,1,0-2.21-2.2L11.705,16a1.557,1.557,0,0,0-.045,2.151l9.4,9.418a1.56,1.56,0,0,0,2.21-2.2Z",
    transform: "translate(9.99 8.6)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDesktop);
export default __webpack_public_path__ + "static/media/back-desktop.32ca427f3d68fb0b8366aebe266e5bdd.svg";
export { ForwardRef as ReactComponent };